import { type } from '@/utils/type'

export const DEBUG_AUTOSAVE =  type('DEBUG_AUTOSAVE')
export const DEBUG_ADD_ITEMS =  type('DEBUG_ADD_ITEMS')
export const DEBUG_TOGGLE_STATE =  type('DEBUG_TOGGLE_STATE')
export const DEBUG_UPDATE_FILTER =  type('DEBUG_UPDATE_FILTER')
